import es_lang from './es.json'
import en_lang from './en.json'
import pt_lang from './pt.json'

const es = {
  title: es_lang.title,
  autor: es_lang.autor,
  url: es_lang.url,
  narrativa: es_lang.narrativa,
  intro: es_lang.intro,
  historia_principal: es_lang.historia_principal,
  creditos: es_lang.creditos,
  creditos_texto: es_lang.creditos_texto,
  indice: es_lang.indice,
  stories: {
    'peru-shipibo': require('./../data/es/peru-shipibo.json'),
    'peru-awajun': require('./../data/es/peru-awajun.json'),
    'colombia': require('./../data/es/colombia.json'),
    'brasil': require('./../data/es/brasil.json'),
    'ecuador-secoya': require('./../data/es/ecuador-secoya.json')
  }
}

const en = {
  title: en_lang.title,
  autor: en_lang.autor,
  url: en_lang.url,
  narrativa: en_lang.narrativa,
  intro: en_lang.intro,
  historia_principal: en_lang.historia_principal,
  creditos: en_lang.creditos,
  creditos_texto: en_lang.creditos_texto,
  indice: en_lang.indice,
  stories: {
    'peru-shipibo': require('./../data/en/peru-shipibo.json'),
    'peru-awajun': require('./../data/en/peru-awajun.json'),
    'colombia': require('./../data/en/colombia.json'),
    'brasil': require('./../data/en/brasil.json'),
    'ecuador-secoya': require('./../data/en/ecuador-secoya.json')
  }
}

const pt = {
  title: pt_lang.title,
  autor: pt_lang.autor,
  url: pt_lang.url,
  narrativa: pt_lang.narrativa,
  intro: pt_lang.intro,
  historia_principal: pt_lang.historia_principal,
  creditos: pt_lang.creditos,
  creditos_texto: pt_lang.creditos_texto,
  indice: pt_lang.indice,
  stories: {
    'peru-shipibo': require('./../data/pt/peru-shipibo.json'),
    'peru-awajun': require('./../data/pt/peru-awajun.json'),
    'colombia': require('./../data/pt/colombia.json'),
    'brasil': require('./../data/pt/brasil.json'),
    'ecuador-secoya': require('./../data/pt/ecuador-secoya.json')
  }
}

export default { es, en, pt }
